import { NgModule } from '@angular/core';
import { LongTooltipDirective } from './long-tooltip.directive';
import { MatSelectLongTooltipDirective } from './mat-select-long-tooltip.directive';


@NgModule({
    declarations: [
        LongTooltipDirective,
        MatSelectLongTooltipDirective,
    ],
    exports: [
        LongTooltipDirective,
        MatSelectLongTooltipDirective,
    ],
})
export class LongTooltipModule { }